export default "__VITE_ASSET__19e1c39c__"